<template>
    <Breadcrumbs main="Apps" title="Leaves" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <LeaveList />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const LeaveList = defineAsyncComponent(() => import("@/components/leaves/leaves.vue"))
</script>